export const checkChristmas = () => {
    const currentDate = new Date(); 
    const startDate = new Date(currentDate.getFullYear(), 11, 10).getTime();
    const endDate = startDate+30*24*60*60*1000;
    return (currentDate>=startDate && currentDate<=endDate) || (currentDate.getMonth() === 0 && currentDate.getDate() < 10);
}  